import { ChartData } from '../../types';
import { sizes } from '../../styles/mediaQueries';

export const getDeviceType = (width: number) =>
	width >= sizes.gte.isDesktopDash ? 'desktop' : 'mobile';

export const adaptStats = (statsArr: number[]): ChartData =>
	statsArr.map((val, i) => ({ name: String(i), percent: val }));
